import { Injectable, OnDestroy } from '@angular/core';
import { NullValidationHandler, OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from '../auth.config';
import { BehaviorSubject, Observable, Subject, Subscription, filter } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../../configs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy  {
  private authSubscription: Subscription = new Subscription();
  private eventSubscription: Subscription = new Subscription();
  private readonly userInfoSubject: Subject<{ name: string, isAdmin: boolean, isVersivoEmployee: boolean }> = new Subject<{ name: string, isAdmin: boolean, isVersivoEmployee: boolean }>();

  constructor(
    private readonly configs: AppConfigService, 
    private readonly oauthService: OAuthService,
    private readonly http: HttpClient,
    private readonly route: Router
  ) {
    this.registerErrorEventSubscription();
    this.registerAuthEventSubscription();
    
    this.configureAuthService();
  }

  ngOnDestroy(): void {
    if (this.authSubscription) { this.authSubscription.unsubscribe(); }
    if (this.eventSubscription) { this.authSubscription.unsubscribe(); }
  }  

  private _lastError: string = "";
  private set lastError(val: string) {
    console.log('setting last error to:' + val);
    this._lastError = val;
    this._lastErrorSubject.next(val);
  }
  get lastError() {
    return this._lastError;
  }
  private _lastErrorSubject = new BehaviorSubject<string>('');
  getLastError(): Observable<string> {
    return this._lastErrorSubject;
  }

  isAuthenticated() {
    return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
  }
  userInfo(): Observable<{ name: string, isAdmin: boolean, isVersivoEmployee: boolean }> {
    this.loadUserInfo();
    return this.userInfoSubject;
  }
  private loadUserInfo() {    
    this.oauthService.loadUserProfile().then((_: any) => {
      this.http.get(`${this.configs.get().apiUrl}/users/me`)
        .subscribe({ 
          next: (_: any) => {
            this.userInfoSubject.next({ name: _.firstName, isAdmin: _.isAdmin ?? false, isVersivoEmployee: _.isVersivoEmployee ?? false });
          },
          error: (_: any) => { console.error(_); this.lastError = _.error; }
        });
    })
    .catch(_ => {
      console.error(_);
      this.lastError = _.error; 
      setTimeout(() => this.loadUserInfo(), 1000);
    });
  }

  login(redirectUrl: string | undefined = undefined) {
    localStorage.setItem('dexio_redirect', this.route.url);
    this.oauthService.loadDiscoveryDocumentAndTryLogin({customHashFragment: window.location.search}).then(_ => {
      if (!this.oauthService.hasValidAccessToken()) {
        this.oauthService.initCodeFlow();
      } else {
        this.oauthService.setupAutomaticSilentRefresh();
      }
    });
  }

  logoff(): void {
    sessionStorage.removeItem('hasLoaded');
    this.oauthService.logOut();
    this.removeOAuthCookie();
  }

  private registerErrorEventSubscription() {
    this.eventSubscription = this.oauthService.events.subscribe(e => {
      (e instanceof OAuthErrorEvent) ? console.error(e) : console.log(e);
      if (e instanceof OAuthErrorEvent && e.type == 'invalid_nonce_in_state') {
        window.location.reload();
      }
    });   
  }
  private registerAuthEventSubscription() {
    this.authSubscription = this.oauthService.events
      .pipe(filter((e) => e.type == "token_received"))
      .subscribe((_) => { 
        this.oauthService.loadUserProfile();
        // window.location.reload();
    });
  }
  private configureAuthService() {
    const authConfigs = authCodeFlowConfig;
    authConfigs.issuer = this.configs.get().authIssuer;
    authConfigs.clientId = this.configs.get().clientId;
    this.oauthService.configure(authConfigs);    
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
  }
  private removeOAuthCookie() {
    var name = ".AspNetCore.Identity.Application";
    document.cookie = name + "=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
